import { useWidget, useVote } from '@telescope/cassini-hooks';
import { useAuth } from 'features';
import { SnapshotType } from 'types';

export const useSocialShare = () => {
    const vote = useVote();
    const { data: { type: snapshotType, bingoSettings } } = useWidget({ select: (data: any) => data.snapshot });
    const shareTypes = bingoSettings?.settings?.ruleset_parameters.shareTypes;

    const { user } = useAuth();

    const socialShare = (actionType: string) => {
        const { user_id, method } = user?.user || {};

        const isEnabled = shareTypes.find((type: { name: string }) => type.name === actionType);

        if (!user_id || snapshotType !== SnapshotType.OPEN || !isEnabled || !user?.submitted) return;

        try{
            vote({user_id, method: method, action_type: actionType});
        } catch (error) {
            // not displaying error modal here, as it's unneccessary for the UX with social shares
            console.error(error);
        }
    };

    return socialShare;
};